export const decode = (str) => global.atob(str);



// WEBPACK FOOTER //
// ./src/DecodingHelper.js